// Config for application roles
export const ROLES = {
  ZINGWORKS: "zingworks",
  SUPERADMIN: "superadmin",
  ADMIN: "admin",
  USER: "user",
  AUDITOR: "auditor",
  AUDITEE: "auditee",
  INCHARGE: "incharge",
};

// Config for role selection during user creation
export const rolesForUserMaster = [
  {
    label: "Admin",
    value: "admin"
  },
  {
    label: "User",
    value: "user"
  },
  // {
  //   label: "Auditor",
  //   value: "auditor"
  // },
  // {
  //   label: "Auditee",
  //   value: "auditee"
  // },
  // {
  //   label: "Incharge",
  //   value: "incharge"
  // },
]


// Config to retrive a application role name
export const appRoleNameConfig = {
  "zingworks": "Zingworks Admin",
  "superadmin": "Super Admin",
  "admin": "Admin",
  "user": "User",
  "auditor": "Auditor",
  "auditee": "Auditee",
  "incharge": "Incharge",
}

export const getRelativeRoleName = (key) => {
  return appRoleNameConfig[key] || "Not Available";
};